// src/store/slices/backgroundjobs/backgroundJobSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BackgroundJobProgressDTO } from '../../../types/backgroundjobs/BackgroundJobTypes';

interface BackgroundJobState {
  activeJob: BackgroundJobProgressDTO | null;
  jobs: BackgroundJobProgressDTO[];
  isPolling: boolean;
}

const initialState: BackgroundJobState = {
  activeJob: null,
  jobs: [],
  isPolling: false,
};

const backgroundJobSlice = createSlice({
  name: 'backgroundJob',
  initialState,
  reducers: {
    setActiveBackgroundJob(
      state,
      action: PayloadAction<BackgroundJobProgressDTO | null>
    ) {
      state.activeJob = action.payload;
    },

    setBackgroundJobs(
      state,
      action: PayloadAction<BackgroundJobProgressDTO[]>
    ) {
      state.jobs = action.payload;
    },

    setBackgroundJobPolling(state, action: PayloadAction<boolean>) {
      state.isPolling = action.payload;
    },

    clearBackgroundJob(state) {
      state.activeJob = null;
      state.isPolling = false;
    },

    clearBackgroundJobs(state) {
      state.jobs = [];
      state.activeJob = null;
      state.isPolling = false;
    },
  },
});

export const {
  setActiveBackgroundJob,
  setBackgroundJobs,
  setBackgroundJobPolling,
  clearBackgroundJob,
  clearBackgroundJobs,
} = backgroundJobSlice.actions;

export default backgroundJobSlice.reducer;